import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const StyledWrapper = styled(Flex)`
    flex-flow: row nowrap;
    justify-content: space-between;
    flex-shrink: 0;
    align-items: center;
    height: 56px;
    width: 100%;

    z-index: 20;

    box-sizing: border-box;
`;
